export default __webpack_public_path__ + "d55fd7c9ceb76909242a068d7b788bbf.png";